import Loadable from 'pages/SecurityVersions/Loadable';
import reducer from './modules/securityVersions.slice';

export default {
	component: Loadable,
	reducer
};